import { render } from "./CadastrarModeloEtapas.vue?vue&type=template&id=6ac9eb23"
import script from "./CadastrarModeloEtapas.vue?vue&type=script&lang=js"
export * from "./CadastrarModeloEtapas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__